import {
  Box,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import { chevronDownIcon } from '../../assets/index'
import PrimaryButton from './PrimaryButton'
import { contactSubjectOptions } from '../../data/contactContent'
import { contactSectionTitleSx, contactSplitSectionSx } from '../contact/contactLayout'
import {
  contactMobileFormGap,
  contactMobileFormInputSx,
  contactMobileFormLabelSx,
  contactMobileFormSectionGap,
  contactMobileSectionTitleSx,
  contactMobileSubmitButtonSx,
} from '../contact/contactMobileLayout'
import { MOBILE_MQ } from '../../theme/mobileLayout'

const fieldLabelSx = {
  fontSize: 18,
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
  ...contactMobileFormLabelSx,
}

const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '20px',
    bgcolor: 'transparent',
    '& fieldset': {
      borderColor: 'rgba(0,0,0,0.4)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(0,0,0,0.4)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(0,0,0,0.4)',
      borderWidth: 1,
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: 18,
    lineHeight: 'normal',
    color: '#111',
    py: { xs: '16px', md: '20px' },
    px: '24px',
    ...contactMobileFormInputSx,
    '&::placeholder': {
      color: 'rgba(17,17,17,0.6)',
      opacity: 1,
    },
  },
  '& .MuiSelect-select': {
    fontSize: 18,
    lineHeight: 'normal',
    color: '#111',
    py: { xs: '16px', md: '20px' },
    px: '24px',
    [MOBILE_MQ]: contactMobileFormInputSx[MOBILE_MQ],
  },
}

function SelectChevronIcon(props) {
  return (
    <Box
      component="span"
      {...props}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        pointerEvents: 'none',
      }}
    >
      <Box component="img" src={chevronDownIcon} alt="" sx={{ width: 24, height: 24, display: 'block' }} />
    </Box>
  )
}

function FormField({ label, children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
      <Typography sx={fieldLabelSx}>{label}</Typography>
      {children}
    </Box>
  )
}

function ContactFormFields() {
  return (
    <Box
      component="form"
      onSubmit={(e) => e.preventDefault()}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        width: '100%',
        ...contactMobileFormGap,
      }}
    >
      <FormField label="Full Name *">
        <TextField fullWidth placeholder="Enter your full name" sx={inputSx} />
      </FormField>

      <FormField label="Email Address *">
        <TextField fullWidth type="email" placeholder="your.email@gmail.com" sx={inputSx} />
      </FormField>

      <FormField label="Phone Number *">
        <TextField fullWidth placeholder="+91 XXXXX XXXXX" sx={inputSx} />
      </FormField>

      <FormField label="Subject *">
        <Select
          fullWidth
          displayEmpty
          defaultValue=""
          IconComponent={SelectChevronIcon}
          renderValue={(selected) =>
            selected ? (
              selected
            ) : (
              <Typography sx={{ color: 'rgba(17,17,17,0.6)', fontSize: 18, [MOBILE_MQ]: { fontSize: 14 } }}>
                Select You Query
              </Typography>
            )
          }
          sx={{
            ...inputSx,
            '& .MuiSelect-icon': {
              color: '#111',
              right: 24,
            },
          }}
        >
          {contactSubjectOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormField>

      <FormField label="Message *">
        <TextField
          fullWidth
          multiline
          minRows={4}
          placeholder="Tell us how we can help you...."
          sx={{
            ...inputSx,
            '& .MuiOutlinedInput-input': {
              ...inputSx['& .MuiOutlinedInput-input'],
              pb: { xs: '40px', md: '80px' },
            },
          }}
        />
      </FormField>

      <PrimaryButton
        type="submit"
        sx={contactMobileSubmitButtonSx}
      >
        Send Message
      </PrimaryButton>
    </Box>
  )
}

export default function ContactForm({ showHeading = true }) {
  if (!showHeading) {
    return (
      <Box sx={{ width: '100%', maxWidth: 800 }}>
        <ContactFormFields />
      </Box>
    )
  }

  return (
    <Box component="section" sx={{ ...contactSplitSectionSx, ...contactMobileFormSectionGap }}>
      <Typography component="h2" sx={{ ...contactSectionTitleSx, ...contactMobileSectionTitleSx }}>
        Send Us a Message
      </Typography>
      <Box sx={{ width: { xs: '100%', md: 600, lg: 800 }, minWidth: 0 }}>
        <ContactFormFields />
      </Box>
    </Box>
  )
}
